import { Component, ElementRef, Input, Output, EventEmitter, OnInit, AfterViewChecked } from '@angular/core';

import { EventsService } from '../../shared/Events.service';
import {ElectionService} from '../../shared/election-service/election.service';
import { SettingsService } from '../../shared/settings/settings.service';

declare let componentHandler: any;


@Component({
    selector: 'candidates-info',
    template: require('./candidates.component.html')

})
export class CandidatesComponent implements OnInit,  AfterViewChecked{

    candidatesInfo: Array<Object> = [];
    questionsInfo: Array<Object> = [];
    isCandidateInfoRetrieved:boolean = false;
    error: any;
    tabActivated:boolean = false;
    appSettings: Object;

    isRegularElection:boolean;
    isRegularPrimary:boolean;
    regularElectionDate: string;
    isSpecialElection:boolean;
    isSpecialPrimary:boolean;
    specialElectionDate: string;
    partyList:Array<string> = [];
    specialElectionPartyList:Array<string> = [];
    electionList:Array<Object> = [];
    specialElectionList:Array<Object> = [];
    specialElectionCandidates: Array<Object> = [];

    private selectedAddressLocation:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService,private _electionService: ElectionService, private _settingsService: SettingsService) { 

        
    }

    ngOnInit() {

        //subscribe to the selected address from the address search
        this._eventsService.selectedAddressObject$.subscribe(address => {
         
                //get the current address
                this.selectedAddressLocation = address["addressLocation"];


            }
            
        ); 

        //subscribe to the search invoked event, once a search is begun
        this._eventsService.searchInvoked$.subscribe(
            address => {
                this.selectedAddressLocation = address["addressLocation"];
                this.isCandidateInfoRetrieved = false;

                this.selectedAddressLocation ? this.getCandidatesInformation() : console.log("Address location is undefined");

            }

        );

        // Get app settings from settings service      
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings[0];

                let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Candidates'; });
                this.tabActivated = currentTabSettings[0].activate;
            
                this.isRegularElection = this.appSettings["regularElection"];
                this.isRegularPrimary = this.appSettings["regularPrimary"];
                this.regularElectionDate = this.appSettings["regularElectionDate"];
                this.isSpecialElection = this.appSettings["specialElection"];
                this.isSpecialPrimary = this.appSettings["specialPrimary"];
                this.specialElectionDate = this.appSettings["specialElectionDate"];
            // this.electionServiceURL = this.appSettings["electionServiceURL"];
            },
            err => { this.error = true }
        );       
     
    }

    ngAfterViewChecked() {

        componentHandler.upgradeAllRegistered();
    }

    getCandidatesInformation() {
        //web service call to get the candidates
        this._electionService
            .getCandidates(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(candidates => {

                var sortingCount:number = 0;
                candidates.sort((n1, n2) =>{
                    let partyRanks:Array<String> = ["Democratic", "Republican", "Libertarian"];
                    if(n1["Rank"] > n2["Rank"]){
                        return 1;
                    }else if(n1["Rank"] < n2["Rank"]){
                        return -1;
                    }else if(n1["Rank"] == n2["Rank"] && partyRanks.indexOf(n1["Party"]) < partyRanks.indexOf(n2["Party"])){
                        return -1;
                    }else if(n1["Rank"] == n2["Rank"] && partyRanks.indexOf(n1["Party"]) > partyRanks.indexOf(n2["Party"])){
                        return 1;
                    }
                });

                this.candidatesInfo = candidates

                this.partyList = [];
                this.specialElectionPartyList = [];
                this.electionList = [];
                this.specialElectionList = [];
                this.specialElectionCandidates = [];

                //get all the parties and special election candidates
                for (let c of this.candidatesInfo) {

                    let party = c["Party"];
                    if (!this.partyList.includes(party)) {
                        this.partyList.push(party);
                    }

                    //if the candidate is for a special election
                    if (c["SpecialElection"]) {

                        if (!this.specialElectionPartyList.includes(party)) {
                           this.specialElectionPartyList.push(c["Party"]);
                        }
                        
                        this.specialElectionCandidates.push(c);

                    }

                }

                //OK, now setup the elections array
                //if it's a regular election
                if (this.isRegularElection) {

                    //and it's a regular primary
                    if (this.isRegularPrimary) {
                        for (let pty of this.partyList) {
                            let election = {
                                name: "Regular",
                                party: pty,
                                type: "Primary",
                                date: this.regularElectionDate
                            };

                            this.electionList.push(election)
                        }

                    //ok wait, it's just a regular election
                    } else {

                        let election = {
                            name: "Regular",
                            party: "",
                            type: "General",
                            date: this.regularElectionDate
                        };

                        this.electionList.push(election)
                    }
  

                }

             //now check if there is a special election too
                if (this.isSpecialElection) {

                    //and it's also a special primary
                    if (this.isSpecialPrimary) {
                        for (let pty of this.specialElectionPartyList) {
                            let election = {
                                name: "Special",
                                party: pty,
                                type: "Primary",
                                date: this.specialElectionDate
                            };

                            this.specialElectionList.push(election)
                        }
                        //or not
                    } else {

                       let election = {
                            name: "Special",
                            party: "",
                            type: "General",
                            date: this.specialElectionDate
                        };

                        this.specialElectionList.push(election)
                    }

                }

                //let the application know that it's good to render the HTML'
                this.isCandidateInfoRetrieved = true;
                
            }

            
            )
            .catch(error => {
                this.error = error
                console.log(this.error)
            });
        
        //web service call to get the public questions
        this._electionService
            .getPublicQuestions()
            .then(questions => {
                this.questionsInfo = questions
              
            }
            )
            .catch(error => {
                this.error = error
                console.log(this.error)
            });

            
    }


    // destroy map
    ngOnDestroy() {

    }
    
        onMenuClick() {
            console.log("item was selected")
        }
}


// WEBPACK FOOTER //
// ./app/information/candidates/candidates.component.ts